export default {"src":"/_next/static/media/traded3.14bf41d8.svg","height":43,"width":34};